import { TextInput, TextInputProps, Platform } from "react-native"
import { cn } from "@src/utils"

interface InputProps extends TextInputProps {
  className?: string
  ref?: React.Ref<TextInput>
}

export function Input({ className, multiline, ref, ...props }: InputProps) {
  return (
    <TextInput
      className={cn(
        "flex h-11 w-full rounded-md border border-gray-200 bg-transparent px-3 py-2 text-sm placeholder:text-gray-400 focus:border-blue-500 disabled:cursor-not-allowed disabled:opacity-50",
        Platform.OS === "web" ? "outline-none" : "",
        multiline && "h-20 pt-3",
        className,
      )}
      textAlignVertical={multiline ? "top" : "center"}
      placeholderTextColor="#9CA3AF"
      ref={ref}
      multiline={multiline}
      {...props}
    />
  )
}
